import CustomHTMLElement from './customHTMLElement';

export default class TestimonialQuote extends CustomHTMLElement {
	constructor(properties = {}) {
		super({
			quote: '',
			quotee: '',
			link: '',
			title: '',
		});
		this.setProperties(properties);
		this._createPropertyMethods();

		this._template = require('./templates/testimonialQuote.handlebars');
	}
}